import { useAtom } from "jotai";
import { serviceSync } from "../../../../services/sync.service";
import { useCallback, useEffect, useState } from "react";
import Icon from "../../../commons/Icon";
import { s } from "../../../../lib/styler";
import { libMisc } from "../../../../lib/misc";
import { libSdk } from "../../../../lib/sdk";

export type MessagingThreadViewImageMediaProps = {
}

export default function MessagingThreadViewImageMedia({ }: MessagingThreadViewImageMediaProps) {
    const [{ mediaBlobUrl, open: _open }, setViewImageMedia] = useAtom(serviceSync.atomMessagingThreadViewImageMedia);

    const [open, setOpen] = useState(false);

    const closeHandler = useCallback(() => {
        setViewImageMedia(x => ({ ...x, open: false }));
    }, [mediaBlobUrl]);

    const downloadHandler = useCallback((e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.stopPropagation();
        const filename = mediaBlobUrl!.url.split("/").pop() || "file";
        libMisc.downloadBlobUrl(mediaBlobUrl!.blobUrl, filename);
        // (async () => {
        //     const { blob } = (await db.mediaBlobs.get(mediaBlobUrl!.url))!;
        //     console.log(await libSdk.send("37", "", "wud23", { blob, ext: "png" }));
        // })();
    }, [mediaBlobUrl]);

    useEffect(() => {
        setOpen(_open);
    }, [_open]);

    return (
        <div className={s(`duration-100 absolute left-0 top-0 w-full h-full transition-opacity bg-black/65 flex justify-center items-center cursor-pointer`, {}, [
            ["opacity-100", "opacity-0 pointer-events-none", open]
        ])} onClick={closeHandler}>
            <div className="text-[30px] font-bold text-white w-full h-full px-[25px] md:px-[120px] py-[65px] md:py-[50px]">
                <div className="w-full h-full flex justify-center items-center">
                    {!!mediaBlobUrl && <img className="w-full h-full object-contain" src={mediaBlobUrl.blobUrl} />}
                </div>
            </div>
            <div className="absolute right-[10px] top-[10px] text-gray-100 p-[10px] cursor-pointer duration-200 transition-colors flex gap-[20px] items-center" onClick={closeHandler}>
                <Icon name="bxs-download hover:text-gray-300" size="24px" onClick={downloadHandler} />
                <Icon name="bx-x hover:text-gray-300" size="36px" />
            </div>
        </div>
    );
}